import { ApiClient } from './client.js'
import { PAYMENT_DETAILS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve () {
    return client.get(`${PAYMENT_DETAILS}`)
  },

  update (data) {
    return client.post(`${PAYMENT_DETAILS}`, data)
  }
}
